<template>
    <v-expansion-panel class="promoter-payout-panel" @change="onPanelChange">
        <v-expansion-panel-header>
            <div class="payout-header">
                <v-row class="payout-header-row">
                    <span class="payout-fullname">{{ payout_fullname || '无姓名' }}</span>
                    <div v-if="showNoQrcode" class="promoter-label promoter-no-qrcode">无收款码</div>
                    <v-spacer></v-spacer>
                    <span class="payout-profit">{{ formatPrice(payout.total_actual_profit) }}</span>
                    <span class="payout-currency">CNY</span>
                    <span class="payout-status" :class="{ 'payout-status-done': payout.is_done }">{{
                        payout.status_text }}</span>
                </v-row>
                <v-row class="payout-header-row">
                    <span class="payout-id">{{ payout.id }}</span>
                    <span class="payout-date">{{ payout.dt_created }}</span>
                </v-row>
            </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <div class="payout-content">
                <div class="payout-content-top">
                    <div class="promoter-qrcode-wrapper">
                        <v-img class="promoter-qrcode" :src="payout_qrcode_url" alt="收款码"></v-img>
                    </div>
                    <div class="promoter-form">
                        <div class="promoter-note">{{ promoter_payout_note }}</div>
                        <v-text-field class="payout-note" label="备注" v-model="form.note" :disabled="payout.is_done" />
                        <v-btn color="primary" :width="128" @click="onSetDone(payout)" :disabled="payout.is_done">
                            <span v-if="payout.is_done">已打款</span>
                            <span v-else>完成打款</span>
                        </v-btn>
                    </div>
                </div>
                <v-simple-table>
                    <tr>
                        <td>提现ID</td>
                        <td>{{ payout.id }}</td>
                    </tr>
                    <tr>
                        <td>状态</td>
                        <td>{{ payout.status_text }}</td>
                    </tr>
                    <tr>
                        <td>推广员ID</td>
                        <td>{{ payout.promoter_customer_id }}</td>
                    </tr>
                    <tr>
                        <td>推广员详情</td>
                        <td>
                            <router-link :to="getPromoterDetailLink(payout)">{{ payout_fullname || '无姓名' }} {{
                                payout_phone || '无手机号' }}</router-link>
                        </td>
                    </tr>
                    <tr>
                        <td>佣金总额</td>
                        <td>
                            <span>
                                {{ formatPrice(payout.total_actual_profit) }}
                            </span>
                            <span>
                                = 有效{{ formatPrice(payout.total_profit) }}
                            </span>
                            <span>
                                - 撤销{{ formatPrice(payout.total_revoke_profit) }}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>订单数量</td>
                        <td>
                            <span>
                                有效: {{ payout.total_order }}
                            </span>
                            <span>
                                撤销: {{ payout.total_revoke_order }}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>订单金额</td>
                        <span>
                            有效: {{ formatPrice(payout.total_amount) }}
                        </span>
                        <span>
                            撤销: {{ formatPrice(payout.total_revoke_amount) }}
                        </span>
                    </tr>
                    <tr>
                        <td>后台备注</td>
                        <td>{{ payout.note }}</td>
                    </tr>
                    <tr>
                        <td>实际打款</td>
                        <td>
                            <span>
                                {{ done_profit_text }}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>佣金对账</td>
                        <td>
                            <span>
                                {{ formatPrice(payout.previous_total_payout) }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ formatPrice(payout.current_total_payout) }}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>提现时间</td>
                        <td>{{ payout.dt_created }}</td>
                    </tr>
                    <tr>
                        <td>完成时间</td>
                        <td>{{ payout.dt_done }}</td>
                    </tr>
                </v-simple-table>
                <v-row>
                    <v-col ncols="7">
                        <v-btn color="primary" :width="140" @click="goProfitList(payout)">查看收益记录</v-btn>
                    </v-col>
                    <v-col ncols="5">
                        <v-btn color="red" outlined @click="onDelete(payout)" :disabled="payout.is_done">删除提现</v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>


<script>
import { API } from '@/plugins/api'
import { formatPrice } from '@/plugins/price'
import { promoterPayoutStore } from '@/store/promoter/payout'
import { promoterStore } from '@/store/promoter/promoter'

import _ from 'lodash'

export default {
    props: {
        index: {
            type: Number,
            required: true,
        },
        payout: {
            type: Object,
            required: true,
        },
    },
    data() {
        return { form: { note: null } }
    },
    computed: {
        done_profit_text() {
            let currency = this.payout.done_currency
            if (_.isNil(currency)) {
                return ''
            }
            let profit = this.payout.done_profit
            if (_.isNil(profit)) {
                profit = this.payout.total_actual_profit
            }
            let value = formatPrice(profit, currency)
            return value + ' ' + currency
        },
        promoter() {
            return promoterStore.get(this.payout.promoter_customer_id)
        },
        showNoQrcode() {
            return this.promoter && !this.promoter.payout_qrcode_key
        },
        payout_qrcode_url() {
            let key = this.promoter?.payout_qrcode_key
            let token = this.promoter?.payout_qrcode_token
            if (key && token) {
                return API.urlForImage({ key, token })
            }
            return null
        },
        promoter_payout_note() {
            return this.promoter?.payout_note
        },
        payout_fullname() {
            return this.promoter?.payout_fullname
        },
        payout_phone() {
            return this.promoter?.payout_phone
        }
    },
    methods: {
        formatPrice(value) {
            return formatPrice(value, this.payout.currency)
        },
        async onPanelChange() {
            await promoterPayoutStore.doLoadPayoutPromoter(this.index)
        },
        async onSetDone(payout) {
            await promoterPayoutStore.doSetDone({
                promoter_customer_id: payout.promoter_customer_id,
                payout_order_id: payout.id,
                note: this.form.note,
            })
        },
        getPromoterDetailLink(payout) {
            return {
                path: '/dash/promoter-detail',
                query: {
                    id: payout.promoter_customer_id,
                }
            }
        },
        async goProfitList(payout) {
            this.$router.push({
                path: '/dash/promoter-profit-list',
                query: {
                    payout_order_id: payout.id,
                }
            })
        },
        async onDelete(payout) {
            await promoterPayoutStore.doDelete({
                promoter_customer_id: payout.promoter_customer_id,
                payout_order_id: payout.id,
            })
            this.$toasted.success('删除成功')
        }
    }
}
</script>


<style lang="less" scoped>
@import '~@/styles/common';

.promoter-payout-panel {
    .payout-header {
        .payout-header-row {
            align-items: center;
            justify-content: space-between;
            padding-right: 16px;
        }

        .payout-fullname {
            font-weight: bold;
            min-width: 72px;
        }

        .payout-profit {
            font-size: 18px;
            font-weight: bold;
            font-family: monospace;
            margin-left: 16px;
        }

        .payout-currency {
            margin-left: 4px;
            font-size: 14px;
            position: relative;
            top: 1px;
        }

        .payout-status {
            color: @antGold;
            margin-left: 8px;

            &.payout-status-done {
                color: @antGreen;
            }
        }

        .payout-id,
        .payout-date {
            font-size: 14px;
            margin-top: 12px;
            color: @antTextGrey;
            font-family: monospace;
        }

    }
}

.promoter-label {
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    padding-left: 6px;
    padding-right: 6px;
    font-size: 12px;
    font-weight: bold;
    border-radius: 12px;
    border: solid 1px;
}

.promoter-no-qrcode {
    border-color: @antGold;
    color: @antGold;
}

.payout-content-top {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.promoter-form {
    flex: 1;
    padding-left: 8px;
}

.promoter-qrcode-wrapper {
    max-width: 50%;
    min-width: 100px;
    min-height: 168px;
    padding-top: 8px;
    padding-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>